var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 11.125C12.5757 11.125 12.2188 11.4819 12.2188 11.9219V15.6406C12.2188 15.7869 12.0994 15.9062 11.9531 15.9062H1.85938C1.71308 15.9062 1.59375 15.7869 1.59375 15.6406V5.54688C1.59375 5.40058 1.71308 5.28125 1.85938 5.28125H5.57812C6.01973 5.28125 6.375 4.92598 6.375 4.48438C6.375 4.04277 6.01973 3.6875 5.57812 3.6875H1.85938C0.834395 3.6875 0 4.5209 0 5.54688V15.6406C0 16.6666 0.834395 17.5 1.85938 17.5H11.9531C12.9784 17.5 13.8125 16.6659 13.8125 15.6406V11.9219C13.8125 11.4836 13.4572 11.125 13.0156 11.125ZM16.2031 0.5H10.625C10.1851 0.5 9.82812 0.856934 9.82812 1.29688C9.82812 1.73682 10.1867 2.09375 10.625 2.09375H14.2807L6.07617 10.2949C5.76489 10.6062 5.76489 11.1104 6.07617 11.4218C6.23223 11.5799 6.43477 11.6562 6.64062 11.6562C6.84648 11.6562 7.04836 11.5784 7.20408 11.4228L15.4062 3.22066V6.875C15.4062 7.31494 15.7632 7.67188 16.2031 7.67188C16.6431 7.67188 17 7.3166 17 6.875V1.29688C17 0.856934 16.6447 0.5 16.2031 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpRight);
export default __webpack_public_path__ + "static/media/iconArrowUpRight.eac7de0a471a257d38cd581c40b02f5c.svg";
export { ForwardRef as ReactComponent };